export default "__VITE_ASSET__fec9268b__"